/* eslint-disable no-console */
/* global window, document, navigator, sessionStorage, URLSearchParams, fetch, setTimeout */

const CHATSI_EXPIRED_FLAG = 'chatsi_session_expired';
const CHATSI_EXPIRED_TEXT = 'SESION EXPIRADA';
const CHATSI_STATUS_URL = '/webirc/chatsi-status';
const CHATSI_CHECK_DELAYS = [250, 1000, 2500, 5000, 9000];
const CHATSI_REATTACH_COOLDOWN_MS = 4500;
const CHATSI_MAX_STATUS_MISSES = 3;
let chatsiHiddenOnce = false;
let chatsiLastAttemptAt = 0;
let chatsiStatusMisses = 0;
let chatsiExpiredHandled = false;
let chatsiMethodCursor = 0;
function chatsiLog(...args) {
  try {
    console.log('[CHATSI session-expired]', ...args);
  } catch (err) {
    // noop
  }
}
function chatsiGetActiveNetwork() {
  try {
    if (window.kiwi && window.kiwi.state && typeof window.kiwi.state.getActiveNetwork === 'function') {
      return window.kiwi.state.getActiveNetwork();
    }
  } catch (err) {
    // noop
  }
  return null;
}
function chatsiTextOf(el) {
  return (el && (el.innerText || el.textContent) || '').replace(/\s+/g, ' ').trim();
}
function chatsiIsLoginScreen() {
  const net = chatsiGetActiveNetwork();
  if (net) {
    return false;
  }
  const body = chatsiTextOf(document.body).toLowerCase();
  return body.indexOf('chatear') !== -1 || body.indexOf('bienvenido') !== -1 || !!document.querySelector('.kiwi-startup-common, form.kiwi-welcome-simple-form');
}
function chatsiIsDisconnected(net) {
  if (!net) {
    return false;
  }
  const values = [];
  try {
    values.push(String(net.state || '').toLowerCase());
  } catch (err) {
    // noop
  }
  try {
    values.push(String(net.connection && net.connection.state || '').toLowerCase());
  } catch (err) {
    // noop
  }
  try {
    values.push(String(net.ircClient && net.ircClient.connection && net.ircClient.connection.state || '').toLowerCase());
  } catch (err) {
    // noop
  }
  for (let i = 0; i < values.length; i++) {
    if (values[i] === 'disconnected' || values[i] === 'closed' || values[i] === 'error') {
      return true;
    }
  }
  const body = chatsiTextOf(document.body).toLowerCase();
  return body.indexOf('no estás conectado') !== -1 || body.indexOf('no estas conectado') !== -1 || body.indexOf('not connected') !== -1;
}
function chatsiGatewayStatus() {
  return fetch(`${CHATSI_STATUS_URL}?t=${Date.now()}`, {
    cache: 'no-store',
    credentials: 'same-origin'
  }).then(response => {
    if (!response.ok) {
      return {
        recoverable: false,
        http: response.status
      };
    }
    return response.json().then(json => {
      const recoverable = !!(json && json.ok && json.upstream && (json.session === 'detached' || json.session === 'attached'));
      return {
        recoverable,
        raw: json || null
      };
    });
  }).catch(err => ({
    recoverable: false,
    error: err && err.message ? err.message : String(err || 'fetch failed')
  }));
}
function chatsiCallMethod(obj, method) {
  if (!obj || typeof obj[method] !== 'function') {
    return false;
  }
  obj[method]();
  return true;
}
function chatsiOpenTransport(net) {
  const candidates = [[net && net.connection, 'open'], [net && net.connection, 'connect'], [net && net.connection, 'reconnect'], [net && net.ircClient, 'connect'], [net && net.ircClient, 'reconnect'], [net, 'connect'], [net, 'reconnect']];
  for (let n = 0; n < candidates.length; n++) {
    const idx = (chatsiMethodCursor + n) % candidates.length;
    const obj = candidates[idx][0];
    const method = candidates[idx][1];
    try {
      if (chatsiCallMethod(obj, method)) {
        chatsiMethodCursor = (idx + 1) % candidates.length;
        chatsiLog('transport method', method);
        return true;
      }
    } catch (err) {
      chatsiLog('method failed', method, err && err.message ? err.message : err);
    }
  }
  return false;
}
function chatsiSetExpiredFlag() {
  try {
    sessionStorage.setItem(CHATSI_EXPIRED_FLAG, '1');
  } catch (err) {
    // noop
  }
}
function chatsiClearExpiredFlag() {
  try {
    sessionStorage.removeItem(CHATSI_EXPIRED_FLAG);
  } catch (err) {
    // noop
  }
}
function chatsiHasExpiredFlag() {
  try {
    if (sessionStorage.getItem(CHATSI_EXPIRED_FLAG) === '1') {
      return true;
    }
  } catch (err) {
    // noop
  }
  try {
    return new URLSearchParams(window.location.search).get(CHATSI_EXPIRED_FLAG) === '1';
  } catch (err) {
    return false;
  }
}
function chatsiClearKiwiSavedState() {
  try {
    if (window.localStorage) {
      window.localStorage.removeItem('chatsi-kiwi-v17');
      window.localStorage.removeItem('kiwi-state');
      for (let i = window.localStorage.length - 1; i >= 0; i--) {
        const key = window.localStorage.key(i) || '';
        if (key === 'kiwi-state' || key.indexOf('chatsi-kiwi') === 0) {
          window.localStorage.removeItem(key);
        }
      }
    }
  } catch (err) {
    chatsiLog('could not clear saved state', err && err.message ? err.message : err);
  }
}
function chatsiGoLoginExpired(reason) {
  if (chatsiExpiredHandled) {
    return;
  }
  chatsiExpiredHandled = true;
  chatsiLog('expired; returning to login', reason);
  chatsiSetExpiredFlag();
  chatsiClearKiwiSavedState();
  try {
    window.CHATSI_SESSION_EXPIRED_REDIRECT = true;
    window.onbeforeunload = null;
  } catch (err) {
    // Ignore: best-effort suppression of the browser leave-page prompt.
  }
  try {
    window.location.replace(`/?${CHATSI_EXPIRED_FLAG}=1&t=${Date.now()}`);
  } catch (err) {
    window.location.href = `/?${CHATSI_EXPIRED_FLAG}=1&t=${Date.now()}`;
  }
}
function chatsiEnsureExpiredStyle() {
  if (document.getElementById('chatsi-session-expired-style')) {
    return;
  }
  const style = document.createElement('style');
  style.id = 'chatsi-session-expired-style';
  style.textContent = `
.chatsi-session-expired-snackbar {
    position: fixed;
    left: 50%;
    bottom: 28px;
    transform: translateX(-50%);
    z-index: 2147483647;
    background: rgba(32, 33, 36, .96);
    color: #fff;
    font: 700 14px/1.2 system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    letter-spacing: .3px;
    padding: 13px 18px;
    border-radius: 999px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .28);
    max-width: calc(100vw - 32px);
    text-align: center;
    pointer-events: none;
}
`;
  document.head.appendChild(style);
}
function chatsiShowExpiredMessageIfNeeded() {
  if (!chatsiHasExpiredFlag()) {
    return;
  }
  chatsiEnsureExpiredStyle();
  const existing = document.querySelector('.chatsi-session-expired-snackbar');
  if (existing) {
    existing.remove();
  }
  const el = document.createElement('div');
  el.className = 'chatsi-session-expired-snackbar';
  el.textContent = CHATSI_EXPIRED_TEXT;
  document.body.appendChild(el);
  chatsiClearExpiredFlag();
  setTimeout(() => {
    try {
      el.remove();
    } catch (err) {
      // noop
    }
  }, 5200);
}
function chatsiAttempt(reason) {
  if (document.hidden) {
    return;
  }
  if (navigator.onLine === false) {
    return;
  }
  if (chatsiIsLoginScreen()) {
    chatsiShowExpiredMessageIfNeeded();
    return;
  }
  const net = chatsiGetActiveNetwork();
  if (!net || !chatsiIsDisconnected(net)) {
    return;
  }
  const now = Date.now();
  if (now - chatsiLastAttemptAt < CHATSI_REATTACH_COOLDOWN_MS) {
    return;
  }
  chatsiLastAttemptAt = now;
  chatsiGatewayStatus().then(status => {
    if (status && status.recoverable) {
      chatsiStatusMisses = 0;
      const net2 = chatsiGetActiveNetwork();
      if (!net2 || !chatsiIsDisconnected(net2)) {
        return;
      }
      chatsiLog('reattach transport', reason);
      chatsiOpenTransport(net2);
      return;
    }
    chatsiStatusMisses += 1;
    chatsiLog('no recoverable session', reason, `misses=${chatsiStatusMisses}`, status || null);
    if (chatsiHiddenOnce && chatsiStatusMisses >= CHATSI_MAX_STATUS_MISSES) {
      chatsiGoLoginExpired(reason);
    }
  });
}
function chatsiSchedule(reason) {
  if (!chatsiHiddenOnce && reason !== 'online') {
    chatsiShowExpiredMessageIfNeeded();
    return;
  }
  CHATSI_CHECK_DELAYS.forEach(delay => {
    setTimeout(() => {
      chatsiAttempt(`${reason}:${delay}`);
    }, delay);
  });
}
function chatsiBind() {
  chatsiLog('loaded source');
  chatsiShowExpiredMessageIfNeeded();
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      chatsiHiddenOnce = true;
      chatsiLog('hidden');
    } else {
      chatsiSchedule('visibilitychange');
    }
  });
  window.addEventListener('pageshow', () => {
    chatsiShowExpiredMessageIfNeeded();
    chatsiSchedule('pageshow');
  });
  window.addEventListener('focus', () => {
    chatsiShowExpiredMessageIfNeeded();
    chatsiSchedule('focus');
  });
  window.addEventListener('online', () => {
    chatsiSchedule('online');
  });
  setTimeout(chatsiShowExpiredMessageIfNeeded, 500);
  setTimeout(chatsiShowExpiredMessageIfNeeded, 1500);
}
if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', chatsiBind);
  } else {
    chatsiBind();
  }
}